import Matter from "matter-js";
import { Container, Graphics, Text } from "pixi.js";
import { PARTICLE_COLORS, PARTICLE_LABELS } from "./rules";
import type { ParticleType } from "./types";

export class Particle {
  public readonly view: Container;
  public readonly body: Matter.Body;
  public readonly ghost: boolean;
  private disc: Graphics;
  private label: Text;
  public type: ParticleType;
  public absorbed = false;

  constructor(type: ParticleType, x: number, y: number, radius = 12, ghost = false) {
    this.type = type;
    this.ghost = ghost;
    this.disc = new Graphics();
    this.label = new Text({
      text: PARTICLE_LABELS[type],
      style: { fontFamily: "Georgia", fontSize: 9, fill: 0x1e1410 },
    });
    this.label.anchor.set(0.5);
    this.view = new Container();
    this.view.addChild(this.disc, this.label);
    if (ghost) this.view.alpha = 0.35;
    this.redraw(radius);

    this.body = Matter.Bodies.circle(x, y, radius, {
      restitution: 0.35,
      friction: 0.02,
      frictionAir: 0.01,
      density: 0.0014,
      label: "particle",
    });
    (this.body as Matter.Body & { particle: Particle }).particle = this;
    if (ghost) {
      (this.body as Matter.Body & { isGhost: boolean }).isGhost = true;
    }
  }

  setType(newType: ParticleType): void {
    this.type = newType;
    this.label.text = PARTICLE_LABELS[newType];
    this.redraw(this.body.circleRadius ?? 12);
  }

  sync(): void {
    this.view.position.set(this.body.position.x, this.body.position.y);
    this.view.rotation = this.body.angle;
  }

  private redraw(radius: number): void {
    this.disc
      .clear()
      .circle(0, 0, radius)
      .fill({ color: PARTICLE_COLORS[this.type] })
      .stroke({ color: 0x3a2a1a, width: 2 });
  }
}
